export default "__VITE_ASSET__jJ6lXbgD__"